import Vue from "vue";
import VueRouter from "vue-router";
import layout from "../layout/index.vue";
import layout_c from "../layout_c/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: { title: "首页" },
  },
  {
    path: "/login_c",
    name: "login_c",
    component: () => import("@/views/login_c/index.vue"),
    meta: { title: "登陆页" },
  },
  {
    path: "/login_b",
    name: "login_b",
    component: () => import("@/views/login_b/index.vue"),
    meta: { title: "登陆页" },
  },
  {
    path: "/layout",
    name: "layout",
    component: layout,
    children: [
      {
        path: "/layout/info2024",
        name: "info2024",
        component: () => import("@/views/information2024/index.vue"),
        meta: { title: "审核管理,报名信息审核2024" },
      },
      {
        path: "/layout/info2024/details",
        name: "details1",
        component: () => import("@/views/information2024/details.vue"),
        meta: { title: "审核管理,报名信息审核2024,报名信息详情" },
      },
      {
        path: "/layout/information",
        name: "information",
        component: () => import("@/views/information/index.vue"),
        meta: { title: "审核管理,报名信息审核2023", keepAlive: true },
      },
      {
        path: "/layout/information/details",
        name: "details",
        component: () => import("@/views/information/details.vue"),
        meta: { title: "审核管理,报名信息审核2023,报名信息详情" },
      },
      {
        path: "/layout/info2022",
        name: "info2022",
        component: () => import("@/views/information2022/index.vue"),
        meta: { title: "审核管理,报名信息审核2022" },
      },
      {
        path: "/layout/info2022/details",
        name: "details1",
        component: () => import("@/views/information2022/details.vue"),
        meta: { title: "审核管理,报名信息审核2022,报名信息详情" },
      },
      {
        path: "/layout/mediaReports",
        name: "mediaReports",
        component: () => import("@/views/mediaReports/index.vue"),
        meta: { title: "运营管理,媒体报道管理" },
      },
      {
        path: "/layout/resultsShow",
        name: "resultsShow",
        component: () => import("@/views/resultsShow/index.vue"),
        meta: { title: "运营管理,成果展示管理" },
      },
      {
        path: "/layout/messageNotice",
        name: "messageNotice",
        component: () => import("@/views/messageNotice/index.vue"),
        meta: { title: "运营管理,消息通知管理" },
      },
      {
        path: "/layout/downloadChrome",
        name: "downloadChrome",
        component: () => import("@/views/downloadChrome/index.vue"),
        meta: { title: "运营管理,浏览器下载管理" },
      },
      {
        path: "/layout/uploadData",
        name: "uploadData",
        component: () => import("@/views/uploadData/index.vue"),
        meta: { title: "比赛管理,上传资料时间" },
      },
      {
        path: "/layout/registered",
        name: "registered",
        component: () => import("@/views/registered/index.vue"),
        meta: { title: "用户管理,注册用户管理" },
      },
      {
        path: "/layout/registered/details",
        name: "registeredDetails",
        component: () => import("@/views/registered/details.vue"),
        meta: { title: "用户管理,注册用户管理,查看成员" },
      },
      {
        path: "/layout/background",
        name: "background",
        component: () => import("@/views/background/index.vue"),
        meta: { title: "用户管理,后台用户管理" },
      },
    ],
  },
  {
    path: "/layout_c",
    name: "layout_c",
    component: layout_c,
    children: [
      {
        path: "/layout_c/index",
        name: "index",
        component: () => import("@/views/home/index.vue"),
        meta: { title: "首页" },
      },
    ],
  },
  {
    path: "/layout_c",
    name: "layout_c",
    component: layout_c,
    children: [
      {
        path: "/layout_c/announcement",
        name: "index",
        component: () => import("@/views/announcement/index.vue"),
        meta: { title: "大赛公告" },
      },
    ],
  },
  {
    path: "/layout_c",
    name: "layout_c",
    component: layout_c,
    children: [
      {
        path: "/layout_c/game/details",
        name: "details",
        component: () => import("@/views/game/details.vue"),
        meta: { title: "我的比赛/详情" },
      },
    ],
  },
  {
    path: "/layout_c",
    name: "layout_c",
    component: layout_c,
    children: [
      {
        path: "/layout_c/game/modify",
        name: "modify",
        component: () => import("@/views/signUp/index.vue"),
        meta: { title: "我的比赛/修改" },
      },
    ],
  },
  {
    path: "/layout_c",
    name: "layout_c",
    component: layout_c,
    children: [
      {
        path: "/layout_c/signUp",
        name: "signUp",
        component: () => import("@/views/signUp/index.vue"),
        meta: { title: "大赛报名" },
      },
    ],
  },
  {
    path: "/layout_c",
    name: "layout_c",
    component: layout_c,
    children: [
      {
        path: "/layout_c/game",
        name: "game",
        component: () => import("@/views/game/index.vue"),
        meta: { title: "我的比赛" },
      },
    ],
  },
  {
    path: "/layout_c",
    name: "layout_c",
    component: layout_c,
    children: [
      {
        path: "/layout_c/problem",
        name: "problem",
        component: () => import("@/views/problem/index.vue"),
        meta: { title: "问题和解答" },
      },
    ],
  },
  {
    path: "/layout_c",
    name: "layout_c",
    component: layout_c,
    children: [
      {
        path: "/layout_c/user",
        name: "user",
        component: () => import("@/views/user/index.vue"),
        meta: { title: "用户" },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
